export const emailNotificationErrorKeys = ['subject', 'body', 'identityVerificationTimeoutDays', 'cc']
